module.exports = __webpack_public_path__ + "media/images/como_funciona/tutorial-select-card-82bfbe151fe422c4478c7806a89ad730.svg";